'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fallbackRoutes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bootstrap = require('./bootstrap');

var _reactRouter = require('react-router');

var _exception = require('../components/exception');

var _localeContext = require('./localeContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var exceptions = {
  403: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg',
    title: '403'
  },
  404: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg',
    title: '404'
  },
  500: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg',
    title: '500'
  }
};

var ExceptionScene = (_dec = (0, _localeContext.localeContext)('Exception', {
  backToHome: '返回首页',
  403: '抱歉，你无权访问该页面',
  404: '抱歉，你访问的页面不存在',
  500: '抱歉，服务器出错了'
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(ExceptionScene, _React$PureComponent);

  function ExceptionScene() {
    _classCallCheck(this, ExceptionScene);

    return _possibleConstructorReturn(this, (ExceptionScene.__proto__ || Object.getPrototypeOf(ExceptionScene)).apply(this, arguments));
  }

  _createClass(ExceptionScene, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var locale = this.getLocale();
      var links = [{
        type: 'primary',
        size: 'large',
        name: locale.backToHome,
        action: function action() {
          _reactRouter.browserHistory.replace(_this2.context.app.route(_bootstrap.bootstrap.getPrefix(_this2.context.app)).resolvePath);
        }
      }];
      var data = exceptions[this.props.route.exception || 404];
      data.desc = locale[data.title];
      return _react2.default.createElement(_exception.Exception, {
        data: data,
        style: {
          minHeight: 500,
          height: '80%'
        },
        links: links
      });
    }
  }]);

  return ExceptionScene;
}(_react2.default.PureComponent), _class2.contextTypes = {
  app: _propTypes2.default.object
}, _class2.propTypes = {
  route: _propTypes2.default.object
}, _temp)) || _class);
var fallbackRoutes = exports.fallbackRoutes = [{
  name: 'noAuth',
  component: ExceptionScene,
  hide: true,
  exception: 403
}, {
  name: 'error',
  component: ExceptionScene,
  hide: true,
  exception: 500
}, {
  path: '*',
  resolvePath: '*',
  component: ExceptionScene,
  hide: true,
  exception: 404
}];


//////////////////
// WEBPACK FOOTER
// ./src/core/fallbackRoutes.js
// module id = 44
// module chunks = 0